import * as React from "react";

import * as jQuery from "jquery";
import "jquery-confirm";

import { JQueryConfirmButton } from "./JQueryConfirmButton";

export interface IJQueryConfirm {
    displayConfirm: boolean;
    title: string;
    content: string;
    buttons: JQueryConfirmButton[];
}

const getButtons = (rawButtons: JQueryConfirmButton[]) => {
    const buttons = {};
    rawButtons.forEach((button) => {
        buttons[button.name] = {
            action: button.action,
            btnClass: button.btnClass,
            text: button.text,
        };
    });
    return buttons;
};

export const JQueryConfirm = (props: IJQueryConfirm) => {

    if (props.displayConfirm) {

        const jqConfirm = $.confirm({
            animateFromElement: false,
            animation: "top",
            backgroundDismiss: true,
            buttons: getButtons(props.buttons),
            content: props.content,
            draggable: false,
            escapeKey: true,
            onContentReady: function () { // tslint:disable-line
                const self = this;

                // Put focus on the first button after the modal has opened.
                this.$body.find("button").first().focus();

                // When user shift-tabs on first button, return focus to last button.
                this.$body.find("button").first().keydown((event) => {
                    if (event.which === 9 && event.shiftKey) {
                        event.preventDefault();
                        self.$body.find("button").last().focus();
                    }
                });

                // When user tabs on last button, return focus to first button.
                this.$body.find("button").last().keydown((event) => {
                    if (event.which === 9 && !event.shiftKey) {
                        event.preventDefault();
                        self.$body.find("button").first().focus();
                    }
                });

                // Cancel arrow keys events so page does not scroll behind modal when arrow keys used.
                this.$body.keydown((event) => {
                    if (event.which === 37 || event.which === 38 || event.which === 39 || event.which === 40) {
                        event.preventDefault();
                    }
                });

                // Also cancel using spacebar to activate buttons.
                this.$body.keyup((event) => { // Has to be .keyup to work on Firefox.
                    if (event.which === 32) {
                        event.preventDefault();
                    }
                });
            },
            theme: "supervan",
            title: props.title,
        });

        return null; // This component doesn't render any actual HTML, it just executes some JavaScript.
    } else {
        return null;
    }

};
